/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import AppBaseScreen from "../../components/AppBaseScreen";
import Rocket from "../../assets/logo/rocket.svg";
import {
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { withdrawStatusTheme } from "./theme";
import AppButton from "../../components/AppButton";
import { ContentCopy, Home, InfoOutlined } from "@mui/icons-material";
import { getWithdraw } from "../../store/api";
import {
  findCurrency,
  formatCryptoDecimals,
  formatNumber,
  getCommonConsts,
  getMerchantName,
  isFiatTransaction,
  isTotalFeeAvailable,
  trimText,
} from "../../utils";
import AppStatus from "../../components/AppStatus";
import { useDispatch, useSelector } from "react-redux";
import { showFeedbackSurvey, showMessageBar } from "../../store/actions";
import { MESSAGE_BAR_TYPES } from "../../utils/constants";
import {
  TYPE_CREDIT,
  TYPE_DEBIT,
  TYPE_MERCHANT_RECLAIM,
} from "../../store/actions/actionTypes";
import AppToolTip from "../../components/AppTooltip";
import AppFeeComponent from "../../components/AppFeeComponent";

export default function WithdrawDetail() {
  const params = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const account = useSelector(({ Auth }) => Auth?.account)
  const [withdrawData, setWithdrawData] = useState(null);

  useEffect(() => {
    if (params.id) {
      getWithdrawData(params.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const getWithdrawData = async (id) => {
    const resp = await getWithdraw(id);
    dispatch(showFeedbackSurvey());

    setWithdrawData(resp.result);
  };
  const copyText = (text) => {
    try {
      navigator?.clipboard?.writeText(text);
      dispatch(
        showMessageBar(MESSAGE_BAR_TYPES.SUCCESS, t("ReferenceCopied"))
      );
    } catch (err) { }
  };
  const showFees = (data) => {
    if (data?.feeCharged?.hasOwnProperty('feeEnabled')) {
      return data?.feeCharged?.feeEnabled;
    }
    return true;
  }
  if (!withdrawData) {
    return (
      <AppBaseScreen isHeader={false}>
        <Box
          display={"flex"}
          flexDirection="column"
          justifyContent="center"
          alignItems={"center"}
          position={"absolute"}
          width="100%"
          height={"100%"}
          top={0}
          bottom={0}
          left={0}
        >
          <Box marginTop={10} marginBottom={20} marginLeft={"-84px"}>
            <Box className="spin" position={"absolute"}></Box>
            <Rocket style={{ width: 84, position: "absolute" }} />
          </Box>
          <Box>
            <Typography
              fontSize={16}
              textTransform={"capitalize"}
              color={"#F8FAFF"}
              textAlign={"center"}
            >
              {t("fetching transfer details")}
            </Typography>
            <AppButton
              buttontheme={"transparent"}
              startIcon={<Home />}
              title={t("BackDashboard")}
              onClick={() => navigate("/home")}
            />
          </Box>
        </Box>
      </AppBaseScreen>
    );
  }

  const getType = (type) => {
    switch (type) {
      case TYPE_CREDIT:
        return t("ReceivedCredit");
      case TYPE_DEBIT:
        return t("Debit");
      case TYPE_MERCHANT_RECLAIM:
        return t("ReclaimDebit");
      default:
        return "---";
    }
  };
  const PayoutOrderContent = () => {
    const paymentMethod = withdrawData?.accountData?.data?.paymentMethod || withdrawData?.feeCharged?.paymentMethodDisplayName;
    if (withdrawData.status === 4 && withdrawData.deletedAt !== null) {
      return <Box
        sx={{
          fontSize: 14,
          fontWeight: 400,
          color: "#D4D4D8",
          lineHeight: "200%",
        }}>
        <Typography>
          {/* <Trans i18nKey="transfer.travelRuleRejected" /> */}
          <Trans
            components={{
              a: (
                <Link
                  href="mailto:support@rocketfuel.inc"
                  target="_blank"
                  onClick={() => { }}
                />
              ),
            }}
          >
            {t('transfer.travelRuleRejected')}

          </Trans>
        </Typography>
      </Box>
    }

    return <Box>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Typography fontSize={14} fontWeight={400}>
          {t("ReferenceId")}:
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Typography fontSize={14} textAlign={"center"} marginRight={1}>
            {withdrawData.id}
          </Typography>
          <IconButton onClick={() => copyText(withdrawData.id)} aria-label="tracker"
            aria-describedby="refrenceid_copy">
            <ContentCopy htmlColor="#F8FAFF" aria-label="tracker"
              aria-describedby="refrenceid_copy" />
          </IconButton>
        </Box>

      </Box>
      <Box marginBottom={4} marginTop={6}>
        <Grid container sx={{ color: "#F8FAFF", rowGap: 2 }}>
          <Grid item xs={4}>
            <Typography fontSize={14} fontWeight={400}>
              {t("type")}:
            </Typography>
          </Grid>
          <Grid item xs={8} textAlign="right">
            <Typography fontSize={14} fontWeight={400}>
              {getType(withdrawData.type)}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={14} fontWeight={400}>
              {t("status")}:
            </Typography>
          </Grid>
          <Grid item xs={8} textAlign="right">
            <AppStatus status={withdrawData.status} />
          </Grid>
          <Grid item xs={4}>
            <Typography fontSize={14} fontWeight={400}>
              {withdrawData.type === TYPE_DEBIT
                ? t("Amount Requested")
                : t("amount")}
              :
            </Typography>
          </Grid>
          <Grid item xs={8} textAlign="right">
            <Typography fontSize={14} fontWeight={400}>
              {formatNumber(withdrawData.amount)} {withdrawData.currency}
            </Typography>
          </Grid>
          {!!paymentMethod && <>
            <Grid item xs={4}>
              <Typography fontSize={14} fontWeight={400}>
                {t('paymentMethod')}
              </Typography>
            </Grid>
            <Grid item xs={8} textAlign="right">
              <Typography fontSize={14} fontWeight={400}>
                {getCommonConsts(paymentMethod)}
              </Typography>
            </Grid>
          </>}
          {withdrawData?.cryptoCurrency?.fullTitle && (
            <>
              <Grid item xs={5}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("selectPaymentBack")}:
                </Typography>
              </Grid>
              <Grid item xs={7} textAlign="right" >
                <Typography fontSize={14} fontWeight={400}>
                  {withdrawData?.cryptoCurrency?.id
                    ? `${withdrawData?.cryptoCurrency?.id}`
                    : ``}&nbsp;({
                    withdrawData?.cryptoNetwork.toUpperCase()
                  })
                </Typography>
              </Grid>
            </>
          )}

          {(withdrawData.type === TYPE_MERCHANT_RECLAIM ||
            withdrawData.type === TYPE_CREDIT) && (
              <>
                <Grid item xs={6}>
                  <Typography fontSize={14} fontWeight={400}>
                    {t("Merchant Name")}:
                  </Typography>
                </Grid>
                <Grid item xs={6} textAlign="right">
                  <Typography fontSize={14} fontWeight={400}>
                    {getMerchantName(withdrawData.merchant)}
                  </Typography>
                </Grid>
              </>
            )}
          {(!isFiatTransaction(withdrawData) && isTotalFeeAvailable(withdrawData)) && (
            <Grid item xs={12}>
              <AppFeeComponent withdrawData={withdrawData} />
            </Grid>
          )}
          {(!isFiatTransaction(withdrawData) && showFees(withdrawData) && !isTotalFeeAvailable(withdrawData) && (!!withdrawData?.feeCharged?.processingFeePercent || !!withdrawData?.feeCharged?.localProcessingFeeFiat)) && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("processing-fee")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                    {withdrawData?.feeCharged?.localProcessingFeeFiat ? `${withdrawData.feeCharged.localProcessingFeeFiat} ${withdrawData?.feeCharged?.baseCurrency} + ` : ''} {(withdrawData?.feeCharged?.processingFeePercent) ? ` ${withdrawData.feeCharged.processingFeePercent}%` : ""}
                    </Typography>
                  </Grid>
                </>
              )}
          {(isFiatTransaction(withdrawData) && !!withdrawData?.feeCharged?.processingFeePercent && showFees(withdrawData)) && (
            <>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("processing-fee")}:
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}>
                  {withdrawData.feeCharged.localProcessingFeeFlat} {withdrawData?.feeCharged?.baseCurrency} {(withdrawData.feeCharged.processingFeePercent != 0 && withdrawData?.feeCharged?.processingFeePercent) ? `+ ${withdrawData.feeCharged.processingFeePercent}%` : ""}
                </Typography>
              </Grid>
            </>
          )}
          {!!withdrawData?.feeCharged?.localNetworkFee && (
            <>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("Network fees")}:
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}>
                  {withdrawData.feeCharged.localNetworkFee}{" "}
                  {withdrawData?.currency}
                </Typography>
              </Grid>
            </>
          )}
          {(!isFiatTransaction(withdrawData) && !!withdrawData.feeCharged?.localPayoutAmount) && (<>
            <Grid item xs={4}>
              <Typography fontSize={14} fontWeight={400}>
                {t("Amount to be sent")}:
              </Typography>
            </Grid>
            <Grid item xs={8} textAlign="right">
              <Typography fontSize={14} fontWeight={400}>
              {formatNumber(Number(withdrawData.feeCharged?.localPayoutAmount))}{" "}
                {withdrawData?.currency}
              </Typography>
            </Grid>
          </>)}
          {(isFiatTransaction(withdrawData) && !!withdrawData?.feeCharged) && <> <Grid
            item
            xs={6}
          >
            <Typography
              fontSize={14}
              fontWeight={400}
            >
              {t("Amount To Be Sent")}:
            </Typography>
          </Grid>
            <Grid
              item
              xs={6}
            >
              <Typography
                fontSize={14}
                textAlign="right"
                fontWeight={400}
              >
                {formatNumber(withdrawData?.feeCharged?.localPayoutAmount)} {withdrawData?.currency}
              </Typography>
            </Grid></>}
          {!!(withdrawData?.feeCharged?.cryptoCurrencyCurrentRate) && (
            <>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("exchangeRate")}
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}></Typography>

                <Typography fontSize={14} fontWeight={400}>
                  1 {withdrawData.cryptoCurrency.id} ={" "}
                  {formatCryptoDecimals(
                    withdrawData.feeCharged.cryptoCurrencyCurrentRate
                  )}
                  &nbsp;
                  {withdrawData?.currency}
                  &nbsp;
                </Typography>
              </Grid>
            </>
          )}
          {!!(withdrawData?.feeCharged?.rkflRate && withdrawData?.feeCharged?.baseCurrency !== withdrawData?.currency) && (
            <>
              <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("exchangeRate")}
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <Typography fontSize={14} fontWeight={400}></Typography>

                <Typography fontSize={14} fontWeight={400}>
                  <span>1 {findCurrency(account)} =  </span>
                  <AppToolTip
                    enterTouchDelay={0}
                    title={`${withdrawData?.feeCharged?.rkflRate?.toString()} ${withdrawData?.feeCharged?.currency}`}
                    placement="top" arrow>
                    <span>{trimText(withdrawData?.feeCharged?.rkflRate?.toString(), 6)}</span>
                  </AppToolTip>&nbsp;{withdrawData?.feeCharged?.currency}

                </Typography>
              </Grid>
            </>
          )}
          {/* {!!withdrawData.reason && (
                <>
                  <Grid item xs={4}>
                    <Typography fontSize={14} fontWeight={400}>
                      {t("Reason")}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8} textAlign="right">
                    <Typography fontSize={14} fontWeight={400}>
                      {withdrawData.reason}
                    </Typography>
                  </Grid>
                </>
              )} */}
          {/* <Grid item xs={4}>
                <Typography fontSize={14} fontWeight={400}>
                  {t("Hash")}
                </Typography>
              </Grid>
              <Grid item xs={8} textAlign="right">
                <div
                  style={{
                    whiteSpace: "nowrap",
                    width: "14rem",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography fontSize={14} fontWeight={400}>
                    {withdrawData.hash || "---"}
                  </Typography>
                </div>
              </Grid> */}
        </Grid>
        <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
        {(!!withdrawData?.feeCharged?.payoutAmountCrypto || !!withdrawData?.feeCharged?.payoutAmount) && (
          <Box
            sx={{
              display: "flex",
              flexFlow: "row",
              justifyContent: "space-between",
              marginTop: 2,
            }}
          >
            <Typography fontSize={16} color="#F8FAFF">
              {t("AmountReceived")}:
            </Typography>
            <Box>
              <Box
                display={"flex"}
                alignItems={"center"}
                sx={{ cursor: "pointer" }}
              >
                {!isFiatTransaction(withdrawData) && <Typography
                  fontSize={16}
                  fontWeight={700}
                  color="#F8FAFF"
                  textAlign={"right"}
                >
                  {formatCryptoDecimals(
                    withdrawData.feeCharged.payoutAmountCrypto
                  )}{" "}
                  {withdrawData?.cryptoCurrency?.id}
                </Typography>}
                {isFiatTransaction(withdrawData) && <Typography
                  fontSize={16}
                  fontWeight={700}
                  color="#F8FAFF"
                  textAlign={"right"}
                >
                  {formatNumber(
                    withdrawData.feeCharged.payoutAmount
                  )}{" "}
                  {withdrawData?.feeCharged?.currency}
                </Typography>}&nbsp;&nbsp;
                {!isFiatTransaction(withdrawData) && <AppToolTip
                  title={t("approxDisclaimer")}
                  arrow
                  enterTouchDelay={0}
                >
                  <InfoOutlined style={{ color: '#ffffff' }} />
                </AppToolTip>}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      {!!(withdrawData.type === TYPE_MERCHANT_RECLAIM) && (
        <Box>
          <Typography fontSize={16} fontWeight={400} padding={1}>
            {t("note")}: {t("contact-merchant-reclaim")}
          </Typography>
        </Box>

      )}
      {/* {withdrawData.descriptor && (
            <Box>
              <Typography fontSize={16} fontWeight={400} padding={1}>
                {withdrawData.descriptor}
              </Typography>
            </Box>
          )} */}
    </Box>;

  }
  return (
    <AppBaseScreen
      isHeader={true}
      backText={""}
      navigate={true}
      navigatePath={"/home"}
      headerTitle={t("Details")}
    >
      <ThemeProvider theme={withdrawStatusTheme}>
        <Container
          disableGutters
          sx={{
            display: "flex",
            flexFlow: "column",
            justifyContent: "flex-start",
            minHeight: "85vh",
            paddingLeft: 1,
            paddingRight: 1,
            paddingBottom: 2
          }}
        >
          <PayoutOrderContent />
          <AppButton
            disableElevation
            startIcon={<Home />}
            title={t("BackDashboard")}
            onClick={() => navigate("/home")}
          />
        </Container>
      </ThemeProvider>
    </AppBaseScreen>
  );
}
